import React from 'react';
import { Link } from 'react-router-dom';
import { UserIcon, ArrowRightIcon } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { SoftCard } from '../components';
import { detectFormStyleFromMetrics, renderFormStyleIcon, getFormStyleLabel } from '../utils/formStyleUtils';
export const RecentSubmissions = ({ latestSubmissions, totalSubmissions }) => {
    return (React.createElement(SoftCard, { header: {
            title: "Recent Submissions",
            subtitle: "Latest form submissions across all forms"
        }, footer: {
            children: (React.createElement("div", { className: "flex justify-between items-center" },
                React.createElement("div", { className: "text-sm text-gray-600" },
                    "Showing ",
                    Math.min(5, totalSubmissions),
                    " of ",
                    totalSubmissions,
                    " submissions"),
                React.createElement(Link, { to: "/submissions", className: "text-sm font-medium text-orange-500 hover:text-orange-600 flex items-center" },
                    "View All Submissions",
                    React.createElement(ArrowRightIcon, { className: "w-4 h-4 ml-1" }))))
        } },
        React.createElement("div", { className: "divide-y divide-gray-200" }, latestSubmissions.length > 0 ? (React.createElement(React.Fragment, null, latestSubmissions.map(submission => (React.createElement("div", { key: submission.submissionId, className: "p-4 hover:bg-gray-50 transition-colors" },
            React.createElement("div", { className: "flex justify-between items-center" },
                React.createElement("div", { className: "flex items-center" },
                    React.createElement("div", { className: "w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center mr-3" },
                        React.createElement(UserIcon, { className: "w-5 h-5 text-gray-500" })),
                    React.createElement("div", null,
                        React.createElement("h4", { className: "font-medium text-gray-800" }, submission.formName || submission.formKey),
                        React.createElement("p", { className: "text-sm text-gray-500" },
                            submission.userName || 'Unknown User',
                            " \u2022 ",
                            formatDistanceToNow(new Date(submission.sentDate), { addSuffix: true })))),
                React.createElement("div", { className: "flex items-center" },
                    React.createElement("div", { className: "mr-4 flex items-center bg-gray-100 px-2 py-1 rounded text-sm" }, (() => {
                        const formStyle = detectFormStyleFromMetrics(submission.metrics);
                        const icon = renderFormStyleIcon(formStyle);
                        const label = getFormStyleLabel(formStyle);
                        return (React.createElement(React.Fragment, null,
                            React.createElement("span", { className: "mr-1" }, icon),
                            React.createElement("span", { className: "text-gray-700 capitalize" }, label)));
                    })()),
                    React.createElement(Link, { to: `/submissions/${submission.submissionId}`, className: "text-gray-600 hover:text-gray-900 p-1 rounded-md hover:bg-gray-100" },
                        React.createElement(ArrowRightIcon, { className: "w-5 h-5" }))))))))) : (React.createElement("div", { className: "text-center p-8 text-gray-600" }, "No submissions yet")))));
};
export default RecentSubmissions;
